// extracted by mini-css-extract-plugin
module.exports = {"category-list-detail-wrapper":"CategoryListDetail_category-list-detail-wrapper__2Te33","full-height":"CategoryListDetail_full-height__3YQG_"};